<template>
  <div class="">
    <v-card>
      <v-card-title class="py-2">
        {{ $t('common.maintenance_parts') }} {{maintenancePartsForCar.name}}
      </v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text class="">
        <v-alert
            dense
            outlined
            type="error"
            class=""
            v-if="!loadingMaintenanceParts && error!=''"
        >
          {{ error }}
        </v-alert>
        <div class="py-5" v-if="loadingMaintenanceParts">
          <v-progress-circular
              size="64"
              indeterminate
              color="primary"
              class="mx-auto d-block"
          ></v-progress-circular>
        </div>
      <v-expansion-panels v-if="maintenanceParts && maintenanceParts.categories">
        <v-expansion-panel
              v-for="(category, index0) in maintenanceParts.categories"
              :key="index0"
              v-if="!loadingMaintenanceParts"
          >
            <v-expansion-panel-header class="px-4 justify-start">
              <div class="shrink">
                <v-img class="d-inline-block mr-3" :src="category.category_image" height="25" width="25"/>
              </div>
              <div class="">
                {{ category.category_name }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>              
                <template v-for="(node) in Object.values(nodesData[category.category_code].nodes)">
                  <v-row>
                  <v-col
                    cols="6"
                      class="ma-0 pa-0"
                  >
                    <v-row>
                      <v-col cols="6">                        
                          <img :src="node['node'].node_image" class="maintenanceImg"/>                        
                      </v-col>
                      <v-col cols="6">
                        <h3 class="">{{ node['node'].title }}</h3>
                        <template
                            v-for="(one, index3) in node.parts"
                            
                        >
                          <p
                              :title="$t('common.add_to_cart')"
                              class="ma-0 text-no-wrap"
                              :key="index3"
                              @click.stop="addDummyToCart({
                                                      car: maintenancePartsForCar,
                                                      part: {
                                                        brand: brand,
                                                        part_code: one.part_code,
                                                        name: one.part_name
                                                      }
                                                    })"
                          >
                            <v-btn icon ripple class="ml-0 mr-0" :loading="cartIsLoading">
                              <v-icon
                                  small
                                  color="grey lighten-1"
                              >$cart
                              </v-icon>
                            </v-btn>
                            <span class="pointer">{{ one.part_name }} [ {{ one.part_code }} ]</span>
                          </p>
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                </template>              
            </v-expansion-panel-content>
          </v-expansion-panel>
      </v-expansion-panels>        
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import {mapFields} from 'vuex-map-fields';
import customerForm from '@/components/customer/CustomerForm.vue';
import CommonMixin from "@/mixins/common";
import BeautyCarNumber from "@/components/common/BeautyCarNumber";

export default {
  name: 'MaintenanceParts',
  components: {BeautyCarNumber, customerForm},
  mixins: [CommonMixin],
  data: () => ({
    categories_icons: {
      'brake_front': '$brake1',
      "brake_rear": "$brake2",
      "filters": "$filters",
      "engine": "$engine",
      "belt_drive": "$belts",
      "windscreen": "$windscreen_cleaning_system",
      "fluids": "$fluids",
      "oil": "$fluids",
    }
  }),
  computed: {
    ...mapFields("cart", ["cartIsLoading", "carts"]),
    ...mapFields('garage', [
      'loadingMaintenanceParts',
      'maintenanceParts',
      'maintenancePartsForCar',
    ]),
    brand() {
      return this.maintenanceParts.catalog_name;
    },
    error() {
      if (this.maintenanceParts.error) return this.maintenanceParts.error;
      return '';
    },
    nodesData(){
      let result = {};
      if (this.maintenanceParts && this.maintenanceParts.categories){
        
        this.maintenanceParts.categories.forEach((category)=>{
          category.parts.forEach(part=>{
            
            if(part.node_group){
              if(!result[category.category_code] || !result[category.category_code]['nodes'][part.node_group]){
                if(!result[category.category_code]){
                  result[category.category_code] = {}
                  result[category.category_code]['nodes'] = {}
                }
                result[category.category_code]['nodes'][part.node_group] = {};
                result[category.category_code]['nodes'][part.node_group]['node'] = {
                  'title':part.node_name,
                  'node_image':part.node_image
                }
                result[category.category_code]['nodes'][part.node_group]['parts'] = []
              }
              //console.log('part.node_group==',part.node_group)
              result[category.category_code]['nodes'][part.node_group]['parts'].push(part)
            }
          })          
        })
      }
      return result;
    },    
  },
  methods: {},
}
</script>
<style lang="scss">
.maintenanceImg {
  width: 400px;
  max-width: 95% !important;
  margin: 0 auto;
  display: block;
  border-radius: 10px;
  border: 1px solid map-get($blue-grey, 'lighten-2');
}
</style>